import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.less']
})
export class SpSetupFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
